export default __webpack_public_path__ + "static/media/arrow_back.6ba7f195.svg";